import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=6d61cffb&scoped=true&lang=pug"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=6d61cffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61cffb",
  null
  
)

export default component.exports